import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import Image from "../../Utils/getImage";
import instance from "../../Utils/api";
import CommonTable from "./Common_table";
import GetLink from "../../Utils/GetLink.js";
import { useGlobalContext } from "../../context/Context";
import Suborderstatus from "../components/Suborder_status.jsx";
import SuborderDeadline from "../components/Suborder_deadline.jsx";
import Suborderfabricstatus from "../components/Suborder_Fabricstatus.jsx";
import AssignSuborder from "../components/Assign_suborder.jsx";
import SubAdddocuments from "../components/Suborder_document.jsx";
import UploadImage from "./UploadImage.jsx";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Vieworder = ({
  openviewDialog,
  setopenviewDialog,
  mode,
  selectedOrder,
  selectedsubOrder,
  getSubOrder,
  setgetOrder,
}) => {
  const [orderDetails, setOrderDetails] = useState(null); // State for order details
  const [ordersubDetails, setOrderSubOrderDetails] = useState(null); // State for order details
  const [openLoginDialog1, setOpenLoginDialog1] = useState(false); // Login modal state
  const { commonDialog, setCommonDialog } = useGlobalContext();
  const [commonDialog1, setCommonDialog1] = useState(false);
  const [statusDialog1, setstatusDialog1] = useState(false);
  const [statusDialog2, setstatusDialog2] = useState(false);
  const [deleteDialog1, setdeleteDialog1] = useState(false);
  const [selectedOrders, setSelectedOrder] = useState("");
  const { imageDialog, setImageDialog } = useGlobalContext();

  //handle close
  const handleClose = () => {
    setopenviewDialog(false);
  };

  // Fetch order details by ID
  const fetchOrderDetailsById = async () => {
    try {
      const response = await instance.get(
        `/Order/OrderById?order_id=${selectedOrder._id}`
      );
      setOrderDetails(response.data.data); // Set fetched data to state
      const formatteddata = response?.data?.data?.sub_orders?.map(
        (ordersuborder, index) => ({
          sno: index + 1,
          order_Id: ordersuborder?.sub_order_id,
          design_kind: ordersuborder?.design_kind,
          suborderstatus: ordersuborder?.status,
          subAssignperson: ordersuborder?.assigned_to?.name
            ? ordersuborder?.assigned_to?.name
            : "Unassigned",
          fabricstatus: ordersuborder?.fabric_status,
          consultationsleft:
            ordersuborder?.fabric_given === true ? "Yes" : "No",
          Procure: ordersuborder?.Procure === true ? "Yes" : "No",
          suborderadd: "Add Document & Payment",
          preview: "Add Image",
          totalamount: ordersuborder?.amount,
          Deadline: ordersuborder?.deadline,
          suborderdata: ordersuborder,
        })
      );
      setOrderSubOrderDetails(formatteddata);
    } catch (error) {
      console.error("Error fetching order details:", error.message);
    }
  };
  useEffect(() => {
    if (selectedOrder) {
      fetchOrderDetailsById();
    }
  }, [selectedOrder]);

  // State for suborder details
  const [suborderDetails, setsuborderDetails] = useState(null);
  // console.log(selectedsubOrder);

  // Fetch suborder details by ID
  const fetchSubOrderDetailsById = async () => {
    try {
      const response = await instance.get(
        `/Order/SubOrderById?order_id=${selectedsubOrder._id}`
      );
      setsuborderDetails(response?.data?.data); // Set fetched data to state
      getSubOrder(true);
    } catch (error) {
      console.error("Error fetching suborder details:", error.message);
    }
  };

  useEffect(() => {
    if (selectedsubOrder) {
      fetchSubOrderDetailsById();
    }
  }, [selectedsubOrder]);

  // Handle Row Click for set suborder
  const handleFabricstatus = (ordersuborder) => {
    // console.log(ordersuborder);
    
    if (ordersuborder.suborderdata.status === "Canceled" || ordersuborder.suborderdata.fabric_status === "Acquired") {
      setOpenLoginDialog1(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setOpenLoginDialog1(true);
    }
  };

  // Handle Row Click for set suborder
  const handleAddImageClick = (ordersuborder) => {
    if (ordersuborder.suborderdata.status === "Canceled") {
      setImageDialog(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setImageDialog(true);
    }
  };

  // Handle Row Click for assign order
  const handleSuborderAssignClick = (ordersuborder) => {
    if (ordersuborder.suborderdata.status === "Canceled") {
      setstatusDialog2(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setstatusDialog2(true);
    }
  };

  // Handle Row Click for set suborder
  const handleSuborderstatus = (ordersuborder) => {
    if (ordersuborder.suborderdata.status === "Canceled") {
      setstatusDialog1(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setstatusDialog1(true);
    }
  };

  // Handle Row Click for set deadline suborder
  const handleDeadlinetimeClick = (ordersuborder) => {
    if (ordersuborder.suborderdata.status === "Canceled") {
      setdeleteDialog1(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setdeleteDialog1(true);
    }
  };

  // Handle Row Click for set document suborder
  const handleSubAdddocumnentClick = (ordersuborder) => {
    if (ordersuborder.suborderdata.status === "Canceled") {
      setCommonDialog1(false);
    } else {
      setSelectedOrder(ordersuborder?.suborderdata);
      setCommonDialog1(true);
    }
  };

  return (
    <>
      {mode === "orders" ? (
        <React.Fragment>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openviewDialog}
            className="admin-admins"
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              Order info
              <Typography>
                See the order details for more information
              </Typography>
            </DialogTitle>
            <hr style={{ margin: "8px 0px" }} />
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <section className="add-order">
                <div className="add-employee-title">
                  <Typography>Suborder Bookings</Typography>
                </div>
                <CommonTable
                  columns={[
                    { label: "S.No", field: "sno", },
                    { label: "Order id", field: "order_Id", },
                    {
                      label: "Design kind",
                      field: "design_kind",
                     
                    },
                    {
                      label: "Assign Person",
                      field: "subAssignperson",
                     
                    },
                    {
                      label: "SubOrder Status",
                      field: "suborderstatus",
                     
                    },
                    {
                      label: "Fabric Status",
                      field: "fabricstatus",
                     
                    },
                    {
                      label: "Fabric given",
                      field: "consultationsleft",
                     
                    },
                    { label: "Procure", field: "Procure",  },
                    { label: "Document", field: "suborderadd",  },
                    { label: "final Image", field: "preview",  },
                    {
                      label: "Total Amount",
                      field: "totalamount",
                     
                    },
                    { label: "Deadline", field: "Deadline",  },
                    // { label: "Actions", field: "action",  },
                  ]}
                  rows={ordersubDetails}
                  deadline={true}
                  handleFabricstatus={handleFabricstatus}
                  handleSuborderAssignClick={handleSuborderAssignClick}
                  handleSuborderstatus={handleSuborderstatus}
                  handleDeadlinetimeClick={handleDeadlinetimeClick}
                  handleSubAdddocumnentClick={handleSubAdddocumnentClick} // Pass the handler
                  handleAddImageClick={handleAddImageClick}
                />
                <UploadImage
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                  imageDialog={imageDialog}
                  setImageDialog={setImageDialog}
                />
                <Suborderfabricstatus
                  openLoginDialog={openLoginDialog1}
                  setOpenLoginDialog={setOpenLoginDialog1}
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                />
                <AssignSuborder
                  statusDialog={statusDialog2}
                  setstatusDialog={setstatusDialog2}
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                />
                <Suborderstatus
                  statusDialog={statusDialog1}
                  setstatusDialog={setstatusDialog1}
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                  setgetOrder={setgetOrder}
                />
                <SuborderDeadline
                  deleteDialog={deleteDialog1}
                  setdeleteDialog={setdeleteDialog1}
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                />
                <SubAdddocuments
                  commonDialog={commonDialog1}
                  setCommonDialog={setCommonDialog1}
                  selectedsubOrder={selectedOrders}
                  setReload={fetchOrderDetailsById}
                />
              </section>
              <hr style={{ margin: "15px 0px" }} />
              <section className="add-order">
                <div className="add-employee-title">
                  <Typography>Order booking Person info</Typography>
                </div>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                    <div className="add_emloyee-upload-file">
                      <Image
                        src={orderDetails?.customer_id?.profile_pic}
                        alt="profile_pic"
                      />
                      <Typography variant="h5">
                        {orderDetails?.customer_id?.name
                          ? orderDetails?.customer_id?.name
                          : "----"}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                    <div className="order-content-text">
                      <Typography variant="h5">Order details</Typography>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Payment Status</Typography>
                        <Typography>{orderDetails?.payment_status}</Typography>
                      </div>
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Paid Amount</Typography>
                        <Typography>{orderDetails?.paid_amount}</Typography>
                      </div>
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Payment Amount</Typography>
                        <Typography>{orderDetails?.payment_amount}</Typography>
                      </div>
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Pending Amount</Typography>
                        <Typography>{orderDetails?.pending_amount}</Typography>
                      </div>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Total Amount</Typography>
                        <Typography>{orderDetails?.total_amount}</Typography>
                      </div>
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Ordered date</Typography>
                        <Typography>
                          {new Date(orderDetails?.createdAt).toLocaleString()}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Delivered Date</Typography>
                        <Typography>
                          {new Date(orderDetails?.updatedAt).toLocaleString()}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Status</Typography>
                        <Typography>
                          <span
                            style={{
                              backgroundColor: (() => {
                                switch (orderDetails?.status) {
                                  case "Unassigned":
                                    return "#FFC107"; // Yellow
                                  case "Assigned":
                                    return "#03A9F4"; // Blue
                                  case "Delivered":
                                    return "#4CAF50"; // Green
                                  case "In Payment":
                                    return "#000";
                                  case "In Progress":
                                    return "#3c4ce7";
                                  case "In Transit":
                                    return "#e74c3c";
                                  case "Completed":
                                    return "#4CAF50"; // Shared Green for these statuses
                                  case "Canceled":
                                    return "#F44336"; // Red for Canceled
                                  default:
                                    return "#E0E0E0"; // Default Gray for unknown status
                                }
                              })(),
                              color: (() => {
                                switch (orderDetails?.status) {
                                  case "Unassigned":
                                    return "#212121"; // Dark text for Yellow
                                  case "Assigned":
                                    return "#fff";
                                  case "Delivered":
                                    return "#fff";
                                  case "In Payment":
                                    return "#fff";
                                  case "In Progress":
                                    return "#fff";
                                  case "In Transit":
                                    return "#fff"; // White text for other statuses
                                  case "Completed":
                                    return "#fff"; // White text for other statuses
                                  case "Canceled":
                                    return "#fff"; // White text for other statuses
                                  default:
                                    return "#757575"; // Light gray text for default
                                }
                              })(),
                              padding: "5px 10px",
                              borderRadius: "5px",
                              textAlign: "center",
                              cursor: "pointer",
                            }}
                          >
                            {orderDetails?.status}
                          </span>
                        </Typography>
                      </div>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Deadline Date</Typography>
                        <Typography>
                          {orderDetails?.deadline
                            ? new Date(orderDetails?.deadline).toLocaleString()
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div
                      className="order-content-text"
                      style={{ marginTop: 40 }}
                    >
                      <Typography variant="h5">Address details</Typography>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Name</Typography>
                        <Typography>
                          {orderDetails?.address?.name
                            ? orderDetails?.address?.name
                            : "-----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Mobile number</Typography>
                        <Typography>
                          {orderDetails?.address?.mobile
                            ? orderDetails?.address?.mobile
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Address Type</Typography>
                        <Typography>
                          {orderDetails?.address?.address_type
                            ? orderDetails?.address?.address_type
                            : "-----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">City</Typography>
                        <Typography>
                          {orderDetails?.address?.city
                            ? orderDetails?.address?.city
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">State</Typography>
                        <Typography>
                          {orderDetails?.address?.state
                            ? orderDetails?.address?.state
                            : "----"}
                        </Typography>
                      </div>                      
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Landmark</Typography>
                        <Typography>
                          {orderDetails?.address?.landmark
                            ? orderDetails?.address?.landmark
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Pincode</Typography>
                        <Typography>
                          {orderDetails?.address?.pincode
                            ? orderDetails?.address?.pincode
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Address line 1</Typography>
                        <Typography>
                          {orderDetails?.address?.line_1
                            ? orderDetails?.address?.line_1
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-2">
                        <Typography variant="h5">Address line 2</Typography>
                        <Typography>
                          {orderDetails?.address?.line_2
                            ? orderDetails?.address?.line_2
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div
                      className="order-content-text"
                      style={{ marginTop: 40 }}
                    >
                      <Typography variant="h5">Customer details</Typography>
                      <div className="add_emloyee-content">
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Name</Typography>
                          <Typography>
                            {orderDetails?.customer_id?.name
                              ? orderDetails?.customer_id?.name
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">mobile</Typography>
                          <Typography>
                            {orderDetails?.customer_id?.mobile
                              ? orderDetails?.customer_id?.mobile
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Birth Date</Typography>
                          <Typography>
                            {orderDetails?.customer_id?.dob
                              ? new Date(
                                orderDetails?.customer_id?.dob
                              ).toLocaleDateString()
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Gender</Typography>
                          <Typography>
                            {orderDetails?.customer_id?.Gender
                              ? orderDetails?.customer_id?.Gender
                              : "----"}
                          </Typography>
                        </div>
                      </div>
                      <div className="add_emloyee-content">
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Size</Typography>
                          <Typography>
                            {orderDetails?.customer_id?.size
                              ? orderDetails?.customer_id?.size
                              : "----"}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </section>
              {orderDetails && orderDetails.assigned_to && (
                <>
                  <hr style={{ margin: "10px 0px" }} />
                  <section className="add-order">
                    <div className="add-employee-title">
                      <Typography>Assigned Person info</Typography>
                      {/* <Button>Edit <img src={edit} alt='edit' /></Button> */}
                    </div>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                        <div className="add_emloyee-upload-file">
                          <Image
                            src={orderDetails?.assigned_to?.profile_pic}
                            alt="profile_pic"
                          />
                          <Typography variant="h5">
                            {orderDetails?.assigned_to?.name
                              ? orderDetails?.assigned_to?.name
                              : "----"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                        <div className="add_emloyee-content">
                          <div className="add_emloyee-content-text">
                            <Typography variant="h5">Mobile number</Typography>
                            <Typography>
                              {orderDetails?.assigned_to?.mobile
                                ? orderDetails?.assigned_to?.mobile
                                : "----"}
                            </Typography>
                          </div>
                          <div className="add_emloyee-content-text">
                            <Typography variant="h5">Role</Typography>
                            <Typography>
                              {orderDetails?.assigned_to?.role
                                ? orderDetails?.assigned_to?.role
                                : "----"}
                            </Typography>
                          </div>
                          <div className="add_emloyee-content-text">
                            <Typography variant="h5">Email</Typography>
                            <Typography>
                              {orderDetails?.assigned_to?.email
                                ? orderDetails?.assigned_to?.email
                                : "----"}
                            </Typography>
                          </div>
                        </div>
                        <div className="add_emloyee-content">
                          <div className="add_emloyee-content-text-2">
                            <Typography variant="h5">Address</Typography>
                            <Typography>
                              {orderDetails?.assigned_to?.address
                                ? orderDetails?.assigned_to?.address
                                : "----"}
                            </Typography>
                          </div>
                          <div className="add_emloyee-content-text-2">
                            <Typography variant="h5">
                              Alternate mobile
                            </Typography>
                            <Typography>
                              {orderDetails?.assigned_to?.alt_mobile
                                ? orderDetails?.assigned_to?.alt_mobile
                                : "----"}
                            </Typography>
                          </div>
                          <div className="add_emloyee-content-text-2">
                            <Typography variant="h5">Deadline</Typography>
                            <Typography>
                              {orderDetails?.deadline
                                ? orderDetails?.deadline
                                : "----"}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </section>
                </>
              )}
            </DialogContent>
            <DialogActions>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </DialogActions>
          </BootstrapDialog>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openviewDialog}
            className="admin-admins"
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              SubOrder info
              <Typography>
                See the Suborder details for more information
              </Typography>
            </DialogTitle>
            <hr style={{ margin: "8px 0px" }} />
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <section className="add-order">
                <div className="add-employee-title">
                  <Typography>SubOrder Details</Typography>
                </div>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                    <div className="add_emloyee-upload-file">
                      <Image
                        src={suborderDetails?.customer_id?.profile_pic}
                        alt="profile_pic"
                      />
                      <Typography variant="h5">
                        {suborderDetails?.customer_id?.name
                          ? suborderDetails?.customer_id?.name
                          : "----"}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                    <div className="order-content-text">
                      <Typography variant="h5">Design details</Typography>
                    </div>
                    <div className="add_emloyee-content">
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Name</Typography>
                        <Typography>
                          {suborderDetails?.design_id?.name
                            ? suborderDetails?.design_id?.name
                            : "-----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Description</Typography>
                        <Typography>
                          {suborderDetails?.design_id?.description
                            ? suborderDetails?.design_id?.description
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Created Date</Typography>
                        <Typography>
                          {suborderDetails?.design_id?.createdAt
                            ? new Date(
                              suborderDetails?.design_id?.createdAt
                            ).toLocaleString()
                            : "-----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Updated Date</Typography>
                        <Typography>
                          {suborderDetails?.design_id?.updatedAt
                            ? new Date(
                              suborderDetails?.design_id?.updatedAt
                            ).toLocaleString()
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div
                      className="add_emloyee-content"
                      style={{ marginTop: 40 }}
                    >
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">status</Typography>
                        <Typography>
                          <span
                            style={{
                              backgroundColor: (() => {
                                switch (suborderDetails?.status) {
                                  case "Unassigned":
                                    return "#FFC107"; // Yellow
                                  case "Assigned":
                                    return "#03A9F4"; // Blue
                                  case "Delivered":
                                    return "#4CAF50"; // Green
                                  case "In Payment":
                                    return "#000";
                                  case "In Progress":
                                    return "#3c4ce7";
                                  case "In Transit":
                                    return "#e74c3c";
                                  case "Completed":
                                    return "#4CAF50"; // Shared Green for these statuses
                                  case "Canceled":
                                    return "#F44336"; // Red for Canceled
                                  default:
                                    return "#E0E0E0"; // Default Gray for unknown status
                                }
                              })(),
                              color: (() => {
                                switch (suborderDetails?.status) {
                                  case "Unassigned":
                                    return "#212121"; // Dark text for Yellow
                                  case "Assigned":
                                    return "#fff";
                                  case "Delivered":
                                    return "#fff";
                                  case "In Payment":
                                    return "#fff";
                                  case "In Progress":
                                    return "#fff";
                                  case "In Transit":
                                    return "#fff"; // White text for other statuses
                                  case "Completed":
                                    return "#fff"; // White text for other statuses
                                  case "Canceled":
                                    return "#fff"; // White text for other statuses
                                  default:
                                    return "#757575"; // Light gray text for default
                                }
                              })(),
                              padding: "5px 10px",
                              borderRadius: "5px",
                              textAlign: "center",
                              cursor: "pointer",
                            }}
                          >
                            {suborderDetails?.status
                              ? suborderDetails?.status
                              : "-----"}
                          </span>
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">fabric_status</Typography>
                        <Typography>
                          {suborderDetails?.fabric_status
                            ? suborderDetails?.fabric_status
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Fabric Given</Typography>
                        <Typography>
                          {suborderDetails?.fabric_given === true
                            ? "Yes"
                            : "No"
                              ? suborderDetails?.fabric_given === true
                                ? "Yes"
                                : "No"
                              : "-----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Quantity</Typography>
                        <Typography>
                          {suborderDetails?.quantity
                            ? suborderDetails?.quantity
                            : "----"}
                        </Typography>
                      </div>
                      <div className="add_emloyee-content-text-1">
                        <Typography variant="h5">Dedline Date</Typography>
                        <Typography>
                          {suborderDetails?.deadline
                            ? new Date(
                              suborderDetails?.deadline
                            ).toLocaleDateString()
                            : "----"}
                        </Typography>
                      </div>
                    </div>
                    <div
                      className="order-content-text"
                      style={{ marginTop: 40 }}
                    >
                      <Typography variant="h5">Customer details</Typography>
                      <div className="add_emloyee-content">
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Name</Typography>
                          <Typography>
                            {suborderDetails?.customer_id?.name
                              ? suborderDetails?.customer_id?.name
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">mobile</Typography>
                          <Typography>
                            {suborderDetails?.customer_id?.mobile
                              ? suborderDetails?.customer_id?.mobile
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Birth Date</Typography>
                          <Typography>
                            {suborderDetails?.customer_id?.dob
                              ? new Date(
                                suborderDetails?.customer_id?.dob
                              ).toLocaleDateString()
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">Gender</Typography>
                          <Typography>
                            {suborderDetails?.customer_id?.Gender
                              ? suborderDetails?.customer_id?.Gender
                              : "----"}
                          </Typography>
                        </div>
                      </div>
                      <div className="add_emloyee-content">
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">location</Typography>
                          <Typography>
                            {suborderDetails?.customer_id?.location
                              ? suborderDetails?.customer_id?.location
                              : "----"}
                          </Typography>
                        </div>
                        <div className="add_emloyee-content-text">
                          <Typography variant="h5">
                            Consultations Left
                          </Typography>
                          <Typography>
                            {suborderDetails?.customer_id
                              ?.consultations_left === true
                              ? "Yes"
                              : "No"
                                ? suborderDetails?.customer_id
                                  ?.consultations_left === true
                                  ? "Yes"
                                  : "No"
                                : "----"}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      className="order-content-text"
                      style={{ marginTop: 40 }}
                    >
                      <Typography variant="h5">Documents details</Typography>
                      <div className="add_emloyee-content-text">
                        <Typography variant="h5">Documents View</Typography>
                        {suborderDetails?.documents.length > 0 ? (
                          <GetLink href={suborderDetails.documents}>
                            {suborderDetails?.documents}
                          </GetLink>
                        ) : (
                          "---"
                        )}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </section>
            </DialogContent>
            <DialogActions>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </DialogActions>
          </BootstrapDialog>
        </React.Fragment>
      )}
    </>
  );
};

export default Vieworder;
